<template>
  <div class="dynamic-wrap">
    <div v-for="(item, index) in componentListData" :key="index">
      <lCarousel v-if="item.componentName === 'carousel'" :data="data" :config="item" @btn-click-log="btnClickLog"></lCarousel>
      <lTitle v-if="item.componentName === 'title'" :data="data" :config="item" @btn-click-log="btnClickLog"></lTitle>
      <lImage v-if="item.componentName === 'image'" :data="data" :config="item" @btn-click-log="btnClickLog"></lImage>
      <HomeGoodsPage v-if="item.componentName === 'goodsPagination'" :data="data" :config="item" @btn-click-log="btnClickLog"></HomeGoodsPage>
      <IconBtnList v-if="item.componentName === 'iconBtnList'" :data="data" :config="item" @btn-click-log="btnClickLog"></IconBtnList>
      <DiscountsPanel v-if="item.componentName === 'activityPreview'" :data="data" :config="item" @btn-click-log="btnClickLog"></DiscountsPanel>
    </div>
  </div>
</template>

<script>
import { componentListData } from './mock.js'
import lCarousel from './components/carousel'
import lTitle from './components/title'
import lImage from './components/image'
import HomeGoodsPage from './components/HomeGoodsPage'
import IconBtnList from './components/icon-btn-list'
import DiscountsPanel from './components/discounts-panel'
import { mapGetters } from 'vuex'
export default {
  name: 'index',
  components: {
    lCarousel,
    lTitle,
    lImage,
    HomeGoodsPage,
    IconBtnList,
    DiscountsPanel
  },
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data() {
    return {
      componentListData: [],
      componentName: 'Carousel'
    }
  },
  computed: {
    ...mapGetters(['getEmpNo', 'getApplyId', 'isFormalEmp'])
  },
  created() {
    // this.getTemplateData()
  },
  mounted() {
  },
  watch: {
    data: {
      handler (val) {
        this.componentListData = val
      },
      immediate: true
    }
  },
  methods: {
    btnClickLog (data, callback) {
      typeof callback === 'function' && callback()
    }
  }
}
</script>

<style scoped lang="stylus">
.dynamic-wrap {
  height: 100%;
}
//.page {
//  padding: 0 32rpx;
//}
</style>
